import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  /** URLs à ignorer (pas de loader pour ces appels). */
  private readonly skipUrls: RegExp[] = [
    /\/assets\/i18n\//,        // fichiers de traduction ngx-translate
    /\/assets\/lottie\//,      // animations Lottie
  ];

  constructor(private loaderService: LoaderService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // Header explicite `X-Skip-Loader: true` pour skipper ponctuellement
    if (req.headers.get('X-Skip-Loader') === 'true') {
      const cleanedReq = req.clone({ headers: req.headers.delete('X-Skip-Loader') });
      return next.handle(cleanedReq);
    }

    // URL dans la liste d'exclusion → on n'allume pas le loader
    if (this.skipUrls.some(rx => rx.test(req.url))) {
      return next.handle(req);
    }

    this.loaderService.show();

    return next.handle(req).pipe(
      finalize(() => this.loaderService.hide())
    );
  }
}
